import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { TaskMeta } from './TaskMeta';
import { TaskTypeChip } from './TaskTypeChip';
import { taskPath, taskQuantityText, taskTitle } from '../../../features/operatorTasks/operatorTasksUtils';

/**
 * «Siguiente»: the task the tray puts first, large, with why and since
 * when. Tapping it opens the task, as the bar's primary does.
 *
 * @param {object} props
 * @param {object} props.task
 */
export const NextTaskCard = ({ task }) => (
  <section aria-labelledby="next-task-title">
    <Link
      to={taskPath(task)}
      data-testid="next-task"
      data-task-id={task.id}
      data-type={task.type}
      aria-labelledby="next-task-title next-task-reference"
      className="block space-y-3 rounded-3xl border-2 border-ninja-green bg-white p-4 shadow-sm transition-colors active:bg-ninja-gray dark:bg-[#1a1a1a] dark:active:bg-[#222]"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 id="next-task-title" className="text-xs font-bold uppercase tracking-wide text-ninja-green">
            Siguiente
          </h2>
          <p
            id="next-task-reference"
            data-testid="task-title"
            className="break-words text-2xl font-bold text-ninja-dark dark:text-white"
          >
            {taskTitle(task)}
          </p>
          <p className="text-sm text-text-secondary">
            {[task.company?.name, taskQuantityText(task)].filter(Boolean).join(' · ')}
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <TaskTypeChip type={task.type} />
          <ChevronLeft size={20} aria-hidden="true" className="rotate-180 text-text-muted" />
        </div>
      </div>
      <TaskMeta task={task} />
    </Link>
  </section>
);
